/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Stat_ClicksInputs */

const et_difference_stat_clicks = /** @type {(inputs: Difference_Stat_ClicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikke kuus`)
};

const en_difference_stat_clicks = /** @type {(inputs: Difference_Stat_ClicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicks per month`)
};

/**
* | output |
* | --- |
* | "Clicks per month" |
*
* @param {Difference_Stat_ClicksInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_stat_clicks = /** @type {((inputs?: Difference_Stat_ClicksInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Stat_ClicksInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_stat_clicks(inputs)
	return en_difference_stat_clicks(inputs)
});